import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '120px',
    color: theme.palette.common.white,
    background: '#FF3F4F',
    '&:hover': {
      background: '#E8515D'
    }
  }
}))

interface PropTypes {
  onClick?: () => void
  icon: string
  text: string
}

const OpenIMAdminButton: React.FC<PropTypes> = (props) => {
  const classes = useStyles()
  const { icon, onClick, text } = props

  return (
    <Button
      classes={classes}
      onClick={onClick}
    >
      <img src={icon} alt="xs" height={34} />
      {text}
    </Button>
  )
}

export default React.memo(OpenIMAdminButton)
